import React, {useEffect, useState, memo, useRef} from "react";
import dayjs, {Dayjs} from 'dayjs';
import TextField from '@mui/material/TextField';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import FormHelperText from '@mui/material/FormHelperText';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';

import {useForm, Controller} from 'react-hook-form';
import {useNavigate} from 'react-router-dom'
import {useTranslation} from "react-i18next";
import instance from "../../api/axios";
import {makeStyles} from '@mui/styles';
import {Cookies} from 'react-cookie';
import {useCart} from "../../context/CartContext";
import {loadGoogleMaps, geocodeAddress, reverseGeocode, getDrivingDistanceMeters, getDrivingRoute, attachAutocomplete, isYerevan} from "../../utils/googleMaps";

// Starting point for delivery distance calculation (shop) — fixed coordinates.
const ORIGIN_COORDS = {lat: 40.261910, lng: 44.597933};

// What to tell the customer when the address step cannot be completed.
// "delivery" covers the case where the cart has no delivery region, which is
// what happens whenever the map cannot resolve the address - telling them to
// refresh would just send them round in circles, so point them at the phone.
const SUBMIT_ERRORS = {
    session: {
        am: "\u0536\u0561\u0574\u0562\u0575\u0578\u0582\u0572\u056B \u0576\u057D\u057F\u0561\u0577\u0580\u057B\u0561\u0576\u0568 \u056C\u0580\u0561\u0581\u0565\u056C \u0567\u0589 \u0539\u0561\u0580\u0574\u0561\u0581\u0580\u0565\u0584 \u0567\u057B\u0568 \u0587 \u056F\u0580\u056F\u056B\u0576 \u0583\u0578\u0580\u0571\u0565\u0584\u0589",
        ru: "\u0421\u0435\u0441\u0441\u0438\u044F \u043A\u043E\u0440\u0437\u0438\u043D\u044B \u0438\u0441\u0442\u0435\u043A\u043B\u0430. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430.",
        en: "Your cart session expired. Please refresh the page and try again.",
    },
    delivery: {
        am: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0570\u0561\u0577\u057E\u0565\u056C \u0561\u057C\u0561\u0584\u0578\u0582\u0574\u0568\u0589 \u0536\u0561\u0576\u0563\u0561\u0570\u0561\u0580\u0565\u0584 \u0574\u0565\u0566\u055D +374 99 520223\u0589",
        ru: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443. \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043D\u0430\u043C: +374 99 520223.",
        en: "We could not calculate delivery. Please call us at +374 99 520223.",
    },
};
// Restrict geocoding/autocomplete to Armenia.
const COUNTRY_CODE = "am";

// Maps the app language to a Google Maps language code.
const toGoogleLang = (lng) => (lng === "am" ? "hy" : (lng || "ru"));


const useStyles = makeStyles({
    root: {

        "& label.Mui-focused": {
            color: "#113E2E"
        },
        "& .MuiOutlinedInput-input": {
            color: "#113E2E"
        },

        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#113E2E"
            }
        }
    }
});

function DeliverInfo({toggleTab, priceGlob, totalPrice, showpromo, getChildData}) {
    const {t, i18n} = useTranslation()
    const [some, setSome] = useState([])
    const [region, setRegion] = useState([])
    const [selected, setSelect] = useState(false)
    const today = dayjs();
    const initialValue = dayjs(Date.now());

    const [value, setValue] = useState(initialValue);
    const [selectedCantry, setselectedCantry] = useState('');
    const navigate = useNavigate();
    const [showResults, setShowResults] = useState('')
    const [deliveryPrice, setDeliverPrice] = useState('')
    const [submitError, setSubmitError] = useState(null)
    const { cart, refreshCart, setDeliveryRegion, setDeliveryByDistance } = useCart();

    // --- Google Maps delivery calculator state ---
    const originCoordsRef = useRef(null);
    const autocompleteRef = useRef(null);
    const googleRef = useRef(null);
    const mapDivRef = useRef(null);
    const mapRef = useRef(null);
    const originMarkerRef = useRef(null);
    const destMarkerRef = useRef(null);
    const directionsRendererRef = useRef(null);
    const [distanceKm, setDistanceKm] = useState(null);
    const [computedDelivery, setComputedDelivery] = useState(null);
    const [calculating, setCalculating] = useState(false);
    const [mapReady, setMapReady] = useState(false);
    const [mapError, setMapError] = useState(false);

    let url = process.env.REACT_APP_BASE_URL;

    const [lezu, setlezu] = useState('')
    const [token, setToken] = useState('')
    const [phone, setPhone] = useState(374)
    const handlePhoneCh = event => {
        const result = event.target.value.replace(/\D/g, '');

        setPhone(result);
    };

    // const ALPHA_NUMERIC_DASH_REGEX  = /\p{Letter}/gu;

    const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Zա-ֆԱ-Ֆаа-яА-Я\s\-]+$/;

    let getActiveCountry = JSON.parse(localStorage.getItem('lng'))
    useEffect(() => {
        getActiveCountry?.filter((item) => {
            if (item.active) {
                return setlezu(item.name)
            }

        })

    }, [i18n.language])

    useEffect(() => {
        refreshCart(); // load cart once
    }, []);

    const handleChange = (event) => {
        setselectedCantry(event.target.value);
    };

    const [error, setError] = useState(null);

    const errorMessage = React.useMemo(() => {
        switch (error) {

            case 'invalidDate': {
                return 'Your date is not valid';
            }

            default: {
                return '';
            }
        }
    }, [error]);

    useEffect(() => {
        cartImage();
    }, [selectedCantry, i18n.language]);

    const cartImage = async () => {
        try {
            // small delay (2 seconds)
            await new Promise(resolve => setTimeout(resolve, 3000));

            let lang = i18n.language.slice(0, 2);

            const response = await instance.get(
                `${url}/abio/public/cart/getDeliveryRegions?language=${lang}`
            );

            setRegion(response.data);

        } catch (err) {
            console.log("❌ cartImage error after delay:", err);
        }
    };


    useEffect(() => {
        if (selectedCantry) {
            setDeliveryRegion(selectedCantry);
        }
    }, [selectedCantry]);

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue: setFormValue,

        formState: {errors}
    } = useForm()

    // Create (once) or move the draggable destination marker. Dragging it lets the
    // customer refine the delivery point — the address and price then recalculate.
    const placeDestinationMarker = (destination, fit = true) => {
        const google = googleRef.current;
        const map = mapRef.current;
        const origin = originCoordsRef.current;
        if (!google || !map || !destination) return;

        if (!destMarkerRef.current) {
            destMarkerRef.current = new google.maps.Marker({
                position: destination,
                map,
                label: "B",
                draggable: true,
                title: t("cart.dragHint"),
            });
            destMarkerRef.current.addListener("dragend", async (e) => {
                const pos = {lat: e.latLng.lat(), lng: e.latLng.lng()};
                const res = await reverseGeocode(googleRef.current, pos);
                if (res?.formatted) setFormValue("address", res.formatted, {shouldValidate: true});
                await computeFromCoords(pos, false, res?.formatted, res?.components);
            });
        } else {
            destMarkerRef.current.setPosition(destination);
        }

        if (fit && origin) {
            const bounds = new google.maps.LatLngBounds();
            bounds.extend(origin);
            bounds.extend(destination);
            map.fitBounds(bounds, 60);
        }
    };

    // Draw the driving route line (markers are drawn separately so B stays draggable).
    const renderRouteLine = (result) => {
        const google = googleRef.current;
        const map = mapRef.current;
        if (!google || !map) return;

        if (!directionsRendererRef.current) {
            directionsRendererRef.current = new google.maps.DirectionsRenderer({
                map,
                suppressMarkers: true,
                preserveViewport: true,
                polylineOptions: {strokeColor: "#113E2E", strokeWeight: 5},
            });
        }
        directionsRendererRef.current.setDirections(result);
    };

    // Remove the route line (used when Directions is unavailable).
    const clearRouteLine = () => {
        if (directionsRendererRef.current) {
            directionsRendererRef.current.setMap(null);
            directionsRendererRef.current = null;
        }
    };

    // Compute driving distance from the shop to given destination coords, then let the
    // backend derive & persist the delivery price (rate table + bulky + Yerevan rule).
    const computeFromCoords = async (destination, fit = true, address = null, components = null) => {
        const google = googleRef.current;
        const origin = originCoordsRef.current;
        if (!google || !origin || !destination) return;

        try {
            setCalculating(true);
            let meters;
            try {
                // Preferred: real road route (line) + its distance.
                const route = await getDrivingRoute(google, origin, destination);
                meters = route.meters;
                renderRouteLine(route.result);
            } catch (routeErr) {
                // Directions API not enabled — fall back to distance matrix (no line).
                console.log("directions unavailable, fallback:", routeErr);
                meters = await getDrivingDistanceMeters(google, origin, destination);
                clearRouteLine();
            }
            placeDestinationMarker(destination, fit);

            // Resolve address + components (needed to detect Yerevan) when not provided by the caller.
            let resolvedAddress = address;
            let resolvedComponents = components;
            if (!resolvedComponents) {
                const res = await reverseGeocode(google, destination);
                if (res) {
                    resolvedComponents = res.components;
                    if (!resolvedAddress) resolvedAddress = res.formatted;
                }
            }

            // Round the distance UP to the next whole kilometer (7.1 -> 8, 8.5 -> 9).
            // Send the rounded value to the backend so the price is based on it too.
            const km = Math.ceil(meters / 1000);
            const yerevan = isYerevan(resolvedComponents);
            setDistanceKm(km);

            const updated = await setDeliveryByDistance({
                address: resolvedAddress || "",
                distanceMeters: km * 1000,
                yerevan,
            });
            setComputedDelivery(updated?.deliveryPrice != null ? Number(updated.deliveryPrice) : null);
        } catch (e) {
            console.log("delivery distance calc error:", e);
            setDistanceKm(null);
            setComputedDelivery(null);
        } finally {
            setCalculating(false);
        }
    };

    // Geocode a typed address, then compute the delivery price from the resulting coords.
    const calculateDelivery = async (address) => {
        const google = googleRef.current;
        if (!google || !address) return;

        const destination = await geocodeAddress(google, address, COUNTRY_CODE);
        if (!destination) {
            setDistanceKm(null);
            setComputedDelivery(null);
            return;
        }
        await computeFromCoords(
            {lat: destination.lat, lng: destination.lng},
            true,
            destination.formatted,
            destination.components
        );
    };

    // Load Google Maps once and geocode the origin (shop) address.
    useEffect(() => {
        let cancelled = false;
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

        loadGoogleMaps(apiKey, toGoogleLang(i18n.language))
            .then((google) => {
                if (cancelled) return;
                googleRef.current = google;
                originCoordsRef.current = ORIGIN_COORDS;
                if (!cancelled) setMapReady(true);
            })
            .catch((e) => {
                console.log("Google Maps load error:", e);
                if (!cancelled) setMapError(true);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    // Attach address autocomplete once the map is ready and the address field is rendered.
    useEffect(() => {
        if (!mapReady || autocompleteRef.current) return;
        const google = googleRef.current;
        const input = document.getElementById("deliveryAddressInput");
        if (!google || !input) return;

        autocompleteRef.current = attachAutocomplete(google, input, (place) => {
            setFormValue("address", place.formatted, {shouldValidate: true});
            computeFromCoords({lat: place.lat, lng: place.lng}, true, place.formatted, place.components);
        }, COUNTRY_CODE);
    }, [mapReady]);

    // Initialize the map centered on the shop, with the shop marker.
    useEffect(() => {
        if (!mapReady || mapRef.current) return;
        const google = googleRef.current;
        const origin = originCoordsRef.current;
        if (!google || !origin || !mapDivRef.current) return;

        mapRef.current = new google.maps.Map(mapDivRef.current, {
            center: origin,
            zoom: 11,
            mapTypeControl: true,
            mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "satellite", "hybrid"],
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            },
            streetViewControl: false,
            fullscreenControl: true,
        });
        originMarkerRef.current = new google.maps.Marker({
            position: origin,
            map: mapRef.current,
            label: "A",
            title: t("cart.address"),
        });
    }, [mapReady]);


    const onSubmit = async (data) => {

        navigate('');
        setSubmitError(null);
        const baseurl = `${url}/abio/public/cart/user/initiate`
        try {
            await instance.post(baseurl, {...data}, {
                params: {
                    first_name: data.first_name,
                    last_name: data.last_name,
                    phone_number: data.phone_number,
                    email: data.email,
                    address: data.address,
                    day: data.day,
                    comment: data.comment
                }
            });
            // Only move on once initiate succeeded: it is the call that sets the
            // ABIO_SESSION cookie, and /confirm rejects the order without it.
            toggleTab(3);
        } catch (e) {
            console.error("initiate failed", e);
            // The backend names the reason; a missing delivery region is a very
            // different problem from a stale cart and must not be reported as one.
            const reason = e?.response?.data?.message || "";
            setSubmitError(reason.toLowerCase().includes("delivery region") ? "delivery" : "session");
        }

    };

    const classes = useStyles();

    const onblur = () => {
        setSelect(!selected)
    }
    const getInput = (e) => {


        setShowResults(e.target.value);


    };


    const onfocus = () => {
        setSelect(selected)
    }

    const reorderedRegion = region.length > 1
        ? [region[region.length - 1], ...region.slice(0, -1)]
        : region;

    return (
        <>
            <div className='deliverinfo'>

                <div className='formblock'>
                    <h2>{t("cart.address")} </h2>
                    <p style={{color: 'red', marginBottom: '15px', fontSize: '16px'}}>
                        Ժամը 12:00-ից հետո կատարված պատվերները առաքվում են հաջորդ օրը։
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div>
                            <div className="inputBlock">
                                <div className="inputDivs">
                                    <TextField sx={{minWidth: 250}}
                                               variant="outlined"
                                               label={t("cart.name")}
                                               autoComplete="off"
                                               className={classes.root}
                                               onKeyDown={(event) => {
                                                   if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                                       event.preventDefault();
                                                   }
                                               }}
                                               {...register("first_name", {required: t("cart.errName")})}
                                               error={!!errors?.first_name}
                                               helperText={errors?.first_name ? errors?.first_name.message : null}


                                    />
                                </div>
                                <div className="inputDivs">
                                    <TextField sx={{minWidth: 250}}
                                               className={classes.root}
                                               label={t("cart.surname")}
                                               variant="outlined"
                                               autoComplete="off"
                                               onKeyDown={(event) => {
                                                   if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                                                       event.preventDefault();
                                                   }
                                               }}
                                               {...register("last_name", {required: t("cart.errSurname")})}
                                               error={!!errors?.last_name}
                                               helperText={errors?.last_name ? errors?.last_name.message : null}
                                    />
                                </div>

                            </div>

                            <div className="inputBlock">
                                <div className="inputDivs">
                                    <TextField
                                        sx={{minWidth: 250}}
                                        label={t("cart.phone")}
                                        className={classes.root}
                                        variant="outlined"
                                        inputProps={{maxLength: 16, minLength: 12}}
                                        autoComplete="off"
                                        // type="number"
                                        placeholder="+374XXXXXXXX"


                                        {...register("phone_number", {
                                            required: t("cart.errPhone"),
                                            minLength: 11,
                                            pattern: {

                                                value: /^\+?[0-9]{3}-?[0-9]{8,12}$/,
                                                message: 'Please enter number'
                                            }
                                        })}

                                        error={!!errors?.phone_number}
                                        helperText={errors?.phone_number ? errors?.phone_number.message : null}
                                        value={'+' + phone}
                                        onChange={handlePhoneCh}
                                    />
                                </div>
                                <div className="inputDivs">
                                    <TextField
                                        sx={{minWidth: 250}}
                                        className={classes.root}
                                        label={t("cart.email")}
                                        placeholder={t("cart.email")}
                                        variant="outlined"
                                        autoComplete="off"
                                        {...register("email", {
                                                required: t("cart.errEmail"),
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                    message: 'Invalid email type'

                                                }
                                            }
                                        )}
                                        error={!!errors?.email}
                                        helperText={errors?.email ? errors?.email.message : null}/>

                                </div>
                            </div>
                            <div className="inputBlock">
                                <div className="inputDivs" style={{flex: 1, minWidth: 250}}>
                                    <TextField
                                        id="deliveryAddressInput"
                                        fullWidth
                                        sx={{minWidth: 250}}
                                        className={classes.root}
                                        label={t("cart.addressName")}
                                        placeholder={t("cart.addressPlaceholder")}
                                        variant="outlined"
                                        autoComplete="off"
                                        {...register("address", {required: t("cart.errAddressName")})}
                                        onBlur={(e) => calculateDelivery(e.target.value)}
                                        error={!!errors?.address}
                                        helperText={
                                            errors?.address
                                                ? errors?.address.message
                                                : (mapError ? t("cart.mapUnavailable") : t("cart.addressHint"))
                                        }
                                    />
                                </div>
                            </div>

                            {!mapError ?
                                <div className="inputBlock" style={{flexDirection: "column", alignItems: "stretch"}}>
                                    <div
                                        ref={mapDivRef}
                                        style={{
                                            width: "100%",
                                            height: 280,
                                            borderRadius: 8,
                                            overflow: "hidden",
                                            marginTop: 8,
                                        }}
                                    />
                                    <p style={{margin: "6px 2px 0", fontSize: 13, color: "#666"}}>
                                        {t("cart.dragHint")}
                                    </p>
                                </div> : null}
                            <h2>{t("cart.info")} </h2>
                            <div className="inputBlock">


                                <div className="inputDivs">
                                    {/*
                                        <DatePicker
                                            // mask="10.10.2023"
                                            value={value}
                                            sx={{minWidth: 250}}
                                            defaultValue={today}
                                            disablePast
                                         
                                            //  name = 'day'
                                            className={classes.root}
                                            label={t("cart.day")}
                                          
                                            {...register("day", {required: t("cart.day")})}
                                            onChange={(newValue) => {
                                                setValue(newValue);
                                            }}   
                                           
                                           
                                         

                                            showDaysOutsideCurrentMonth
                                            onError={(newError) => setError(newError)}
                                            slotProps={{
                                              textField: {
                                                required: true,
                                                error: !!errors?.day,
                                                helperText: errors?.day ? errors?.day.message : null,
                                              },
                                            }}


                                        //     renderInput={(params) => <TextField  {...params}    
                                        //    />}
                                         
                                        /> */}

                                    <Controller
                                        name="day"
                                        control={control}
                                        // defaultValue={dayjs()}
                                        // value={value || ''}
                                        render={({
                                                     field: {onChange, value},
                                                     // fieldState: { errors }
                                                 }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label={t("cart.date")}
                                                    // format="DD/MM/YYYY"

                                                    //  defaultValue={dayjs(new Date()) }
                                                    //  value={value || ''}
                                                    className={classes.root}
                                                    control={control}
                                                    disablePast
                                                    showDaysOutsideCurrentMonth
                                                    {...register("day",
                                                        {required: t("cart.errDay")}
                                                    )}
                                                    error={!!errors?.day}
                                                    helperText={errors?.day ? errors?.day.message : null}
                                                    onChange={event => onChange(event.$d?.toLocaleDateString())}
                                                    // slotProps={{ textField: {required: true, error: !!error?.day , helperText: errors?.day ? errors?.day.message : null } }}
                                                />
                                                <FormHelperText
                                                    error={!!errors?.day}

                                                >{errors?.day ? errors?.day.message : null}</FormHelperText>

                                            </LocalizationProvider>
                                        )}
                                    />


                                </div>


                            </div>
                            <div className="inputBlock">
                                <div className="inputDivs">
                                    <TextField sx={{minWidth: 250}}
                                               {...register("comment")}
                                               autoComplete="off"
                                               className={classes.root}
                                               placeholder={t("cart.comment")}
                                               minRows={3}
                                               multiline

                                    />

                                </div>


                            </div>
                        </div>


                        <div className="payleft">
                            <div className="paytitle">
                                <p>{t("cart.total")} </p>
                                <p>{priceGlob?.toLocaleString()} AMD</p>
                            </div>
                            <div className="line"></div>
                            <div className="deliver">
                                <p>{t("cart.delivery")}: </p>
                                <span>
                                    {calculating
                                        ? "…"
                                        : (computedDelivery != null
                                            ? `${computedDelivery.toLocaleString()} AMD (${distanceKm} ${t("cart.km")})`
                                            : "—")}
                                </span>
                            </div>


                            <div className="totalPay">
                                <p>{t("cart.total")} </p>
                                <p>{((priceGlob || 0) + (computedDelivery || 0)).toLocaleString()} AMD</p>
                            </div>

                            <div className="lastbtn">

                                {submitError &&
                                    <p style={{color: 'red', marginBottom: '10px', fontSize: '15px'}}>
                                        {SUBMIT_ERRORS[submitError][i18n.language.slice(0, 2)]}
                                    </p>
                                }
                                <button type="submit">  {t("cart.next")}</button>

                            </div>
                        </div>

                    </form>

                </div>

            </div>

        </>
    )
}

export default memo(DeliverInfo)
